/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react';
import PropTypes from 'prop-types';

// Project Components
import Breadcrumb from '@salesforce/retail-react-app/app/components/breadcrumb';
// Components
import {Box, Fade, Flex, Heading, Text} from '@salesforce/retail-react-app/app/components/shared/ui';

const PageHeader = ({category, productSearchResult, isLoading, searchQuery, ...otherProps}) => {
  return (
    <Box {...otherProps} data-testid="sf-product-list-breadcrumb">
      {/* Breadcrumb */}
      {category && <Breadcrumb categories={category.parentCategoryTree} />}
      {searchQuery && <Text>Search Results for</Text>}
      {/* Category Title */}
      <Flex>
        <Heading as="h2" marginRight={2} size="lg">
          {`${category?.name || searchQuery || ''}`}
        </Heading>
        <Heading as="h2" marginRight={2} size="lg">
          {!isLoading && <Fade in={true}>({productSearchResult?.total})</Fade>}
        </Heading>
      </Flex>
    </Box>
  );
};

PageHeader.propTypes = {
  category: PropTypes.object,
  productSearchResult: PropTypes.object,
  isLoading: PropTypes.bool,
  searchQuery: PropTypes.string,
};

export default PageHeader;
